import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Tooltip } from 'react-tooltip';
import configApi from '../../config';

const UniquePatients = () => {
    const [patients, setPatients] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const token = localStorage.getItem("token");
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    useEffect(() => {
        axios.get(`${configApi.apiEndpoint}/api/Stats/DashboardContext`, config)
            .then(response => {
                setPatients(response.data.totalUniquePatients || response.data.TotalUniquePatients || 0);
                setIsLoading(false);
            })
            .catch(error => {
                console.error('There was an error fetching the unique patient count:', error);
                setIsLoading(false);
            });
    }, []);

    if (isLoading) {
        return (
            <div className="metric-card w-100 h-100">
                <div className="skeleton-circle"></div>
                <div className="metric-data gap-2">
                    <div className="skeleton-box" style={{ width: '80px', height: '28px' }}></div>
                    <div className="skeleton-box" style={{ width: '120px', height: '14px' }}></div>
                </div>
            </div>
        );
    }

    return (
        <div className="metric-card w-100 h-100">
            <div className="metric-icon" style={{ backgroundColor: '#e3f2fd', color: '#1565c0' }}>
                <i className="bi bi-people"></i>
            </div>
            <div className="metric-data">
                <h3 className="fw-bold m-0 text-dark">{patients}</h3>
                <span
                    className="text-muted"
                    style={{ fontSize: '0.85rem', cursor: 'help', borderBottom: '1px dotted #ccc' }}
                    data-tooltip-id="unique-patients-tooltip"
                    data-tooltip-content="Počet jedinečných osôb (na základe mena a priezviska), ktoré prišli aspoň na jeden termín v histórii."
                >
                    Unikátni klienti
                </span>
            </div>
            <Tooltip id="unique-patients-tooltip" place="top" effect="solid" />
        </div>
    );
};

export default UniquePatients;
